import React, { createContext, useContext, useState, useMemo } from 'react'

export const SCOPES = {
  confirmed: 'confirmed',
  suspected: 'suspected',
  possible: 'possible',
}

export const BASE_SCOPE = [SCOPES.confirmed, SCOPES.suspected]

export const LABELS = {
  confirmed: 'Mandiant Confirmed',
  suspected: 'Mandiant Suspected',
  possible: 'Possible Association',
}

export const SCOPE_KEY = 'attribution_scope'

const AttributionScopeContext = createContext()

export const AttributionScopeProvider = ({ children }) => {
  const [scope, setScope] = useState(BASE_SCOPE)

  const handleScopeChange = (newScope) => {
    setScope(newScope)
  }

  const value = useMemo(() => ({
    scope,
    handleScopeChange,
  }), [scope])

  return <AttributionScopeContext.Provider value={value}>{children}</AttributionScopeContext.Provider>
}

const GROUPED_LABELS = {
  [SCOPES.confirmed]: 'Mandiant Confirmed',
  [SCOPES.confirmed + SCOPES.possible]: 'Confirmed / Possible',
  [SCOPES.confirmed + SCOPES.possible + SCOPES.suspected]: 'All',
  [SCOPES.confirmed + SCOPES.suspected]: 'Confirmed / Suspected',
  [SCOPES.possible]: 'Possible Association',
  [SCOPES.possible + SCOPES.suspected]: 'Suspected / Possible',
  [SCOPES.suspected]: 'Mandiant Suspected',
  '': 'None',
}

const getScopeKey = (scope) => {
  return [...scope].sort().join('')
}

export const useAttributionScopeContext = () => {
  const context = useContext(AttributionScopeContext)

  if (!context) {
    throw new Error('useAttributionScopeContext must be used within an AttributionScopeProvider')
  }

  return context
}

export const useAttributionScope = () => {
  const { scope = BASE_SCOPE, handleScopeChange } = useAttributionScopeContext()

  const scopeLabel = GROUPED_LABELS[getScopeKey(scope)]

  return [
    scope,
    handleScopeChange,
    scopeLabel,
  ]
}
